(function() {
  var drawer = document.querySelector('.quick-add-drawer');
  if (!drawer) return;
  var cwLang = (document.documentElement.lang || '').toLowerCase(); var cwIsFR = cwLang.indexOf('fr') === 0; var cwIsDE = cwLang.indexOf('de') === 0;

  function formatMoney(cents) {
    var euros = Math.floor(cents / 100);
    var ct = String(cents % 100).padStart(2, '0');
    return '€ ' + euros + ',' + ct;
  }

  function setPriceInBtn(price, qty) {
    qty = qty || 1;
    var total = price * qty;
    var euros = Math.floor(total / 100);
    var ct = String(total % 100).padStart(2, '0');
    var priceStr = euros + ',' + ct;
    var btn = drawer.querySelector('product-form button[name="add"]');
    if (!btn) return;
    var priceSpan = btn.querySelector('.cw-qs-btn-price');
    if (!priceSpan) {
      priceSpan = document.createElement('span');
      priceSpan.className = 'cw-qs-btn-price';
      btn.appendChild(priceSpan);
    }
    priceSpan.textContent = ' • ' + priceStr;
  }

  function updateAtcOverlay(priceInCents, qty) {
    qty = qty || 1;
    var total = priceInCents * qty;
    var euros = Math.floor(total / 100);
    var ct = String(total % 100).padStart(2, '0');

    var atcPrice = drawer.querySelector('.cw-atc-price');
    if (atcPrice) {
      atcPrice.innerHTML = euros + ',<span style="font-size:0.65em;vertical-align:top;line-height:1.8;">' + ct + '</span>';
      return;
    }

    setPriceInBtn(priceInCents, qty);
  }

  function updateSavings(savingsCents, qty) {
    qty = qty || 1;
    var savingsEl = drawer.querySelector('.js-cw-qs-savings');
    if (!savingsEl) return;
    if (savingsCents > 0) {
      savingsEl.textContent = (cwIsFR ? 'Vous économisez ' : cwIsDE ? 'Du sparst ' : 'Je bespaart ') + formatMoney(savingsCents * qty) + (cwIsFR ? ' avec ce format !' : cwIsDE ? ' mit dieser Größe!' : ' met deze maat!');
      savingsEl.classList.add('is-visible');
    } else {
      savingsEl.classList.remove('is-visible');
      savingsEl.textContent = '';
    }
  }

  function updateStock(card) {
    var stockEl = drawer.querySelector('.js-cw-qs-stock');
    var stockText = drawer.querySelector('.js-cw-qs-stock-text');
    if (!stockEl || !stockText) return;

    var dot = stockEl.querySelector('.cw-qs-stock__dot');
    var inventoryQty = parseInt(card.dataset.variantInventory, 10);
    var available = card.dataset.variantAvailable === 'true';
    var policy = card.dataset.variantInventoryPolicy;

    stockEl.classList.remove('cw-qs-stock--low', 'cw-qs-stock--unavailable');
    dot.style.background = '';
    stockEl.style.color = '';

    if (!available && policy !== 'continue') {
      stockEl.classList.add('cw-qs-stock--unavailable');
      stockText.textContent = cwIsFR ? 'Épuisé' : cwIsDE ? 'Ausverkauft' : 'Uitverkocht';
    } else if (inventoryQty > 0 && inventoryQty <= 10) {
      stockEl.classList.add('cw-qs-stock--low');
      stockText.textContent = (cwIsFR ? 'Plus que ' : cwIsDE ? 'Nur noch ' : 'Nog maar ') + inventoryQty + (cwIsFR ? ' en stock !' : cwIsDE ? ' auf Lager!' : ' op voorraad!');
    } else {
      stockText.textContent = cwIsFR ? 'En stock' : cwIsDE ? 'Auf Lager' : 'Op voorraad';
    }
  }

  function getQty() {
    var qtyInput = drawer.querySelector('input[name="quantity"], .qty-input__input');
    return qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
  }

  function getActiveCard() {
    var picker = drawer.querySelector('.cw-variant-picker');
    if (!picker) return null;
    return picker.querySelector('.cw-variant-card--selected') || picker.querySelector('.cw-variant-card');
  }

  function refreshUI() {
    var card = getActiveCard();
    if (!card) return;
    var price = parseInt(card.dataset.variantPrice, 10) || 0;
    var savings = parseInt(card.dataset.variantSavings, 10) || 0;
    var qty = getQty();
    updateAtcOverlay(price, qty);
    updateSavings(savings, qty);
    updateStock(card);
  }

  function triggerCanopyVariant(variantId) {
    var vp = drawer.querySelector('variant-picker');
    if (!vp) return;
    var dataScript = vp.querySelector('script[type="application/json"]');
    if (!dataScript) return;
    var data = JSON.parse(dataScript.textContent);
    var variant = data.product.variants.find(function(v) { return v.id == variantId; });
    if (!variant) return;
    vp.querySelectorAll('.option-selector').forEach(function(selector, index) {
      var val = variant.options[index];
      selector.querySelectorAll('input.js-option').forEach(function(radio) {
        if (radio.value === val && !radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
  }

function bindQty() {
  var qtyInput = drawer.querySelector('input[name="quantity"], .qty-input__input');
  if (!qtyInput || qtyInput.dataset.cwQsBound) return;
  qtyInput.dataset.cwQsBound = 'true';
  qtyInput.addEventListener('input', function() {
    var card = getActiveCard();
    if (card) setPriceInBtn(parseInt(card.dataset.variantPrice, 10) || 0, getQty());
    refreshUI();
  });
  qtyInput.addEventListener('change', function() {
    var card = getActiveCard();
    if (card) setPriceInBtn(parseInt(card.dataset.variantPrice, 10) || 0, getQty());
    refreshUI();
  });
  var qtyWrap = qtyInput.closest('.qty-input') || qtyInput.parentElement;
  if (qtyWrap) {
    qtyWrap.querySelectorAll('button').forEach(function(b) {
      b.addEventListener('click', function() {
        setTimeout(function() {
          var card = getActiveCard();
          if (card) setPriceInBtn(parseInt(card.dataset.variantPrice, 10) || 0, getQty());
          refreshUI();
        }, 30);
      });
    });
  }
}

  function setGridVisible(picker) {
    var grid = picker.querySelector('.cw-variant-picker__grid');
    if (grid) grid.classList.add('cw-ready');
  }

  function bindCards() {
    var picker = drawer.querySelector('.cw-variant-picker');
    if (!picker || picker.dataset.cwQsInit) return;
    picker.dataset.cwQsInit = 'true';

    var popularBadge = picker.querySelector('.cw-variant-card__badge');
    if (popularBadge) {
      var popularCardBtn = popularBadge.closest('.cw-variant-card');
      if (popularCardBtn && !popularCardBtn.classList.contains('cw-variant-card--soldout')) {
        picker.querySelectorAll('.cw-variant-card').forEach(function(c) {
          c.classList.remove('cw-variant-card--selected');
          c.setAttribute('aria-pressed', 'false');
        });
        popularCardBtn.classList.add('cw-variant-card--selected');
        popularCardBtn.setAttribute('aria-pressed', 'true');
        triggerCanopyVariant(popularCardBtn.dataset.variantId);
        setTimeout(function() {
          refreshUI();
          setGridVisible(picker);
          setTimeout(function() {
            var card = getActiveCard();
            if (card) setPriceInBtn(parseInt(card.dataset.variantPrice, 10) || 0, getQty());
          }, 400);
        }, 100);
      } else {
        refreshUI();
        setGridVisible(picker);
        setTimeout(function() {
          var card = getActiveCard();
          if (card) setPriceInBtn(parseInt(card.dataset.variantPrice, 10) || 0, getQty());
        }, 400);
      }
    } else {
      refreshUI();
      setGridVisible(picker);
      setTimeout(function() {
        var card = getActiveCard();
        if (card) setPriceInBtn(parseInt(card.dataset.variantPrice, 10) || 0, getQty());
      }, 400);
    }

    picker.querySelectorAll('.cw-variant-card').forEach(function(card) {
      card.addEventListener('click', function() {
        if (this.dataset.variantAvailable === 'false') return;
        picker.querySelectorAll('.cw-variant-card').forEach(function(c) {
          c.classList.remove('cw-variant-card--selected');
          c.setAttribute('aria-pressed', 'false');
        });
        this.classList.add('cw-variant-card--selected');
        this.setAttribute('aria-pressed', 'true');

        var price = parseInt(this.dataset.variantPrice, 10) || 0;
        var qty = getQty();
        setPriceInBtn(price, qty);

        refreshUI();
        triggerCanopyVariant(this.dataset.variantId);
      });
    });
  }

  drawer.addEventListener('on:variant:change', function(e) {
    if (!e.detail || !e.detail.variant) return;
    var price = e.detail.variant.price;
    var qty = getQty();
    var picker = drawer.querySelector('.cw-variant-picker');
    if (picker) {
      picker.querySelectorAll('.cw-variant-card').forEach(function(card) {
        if (card.dataset.variantId == e.detail.variant.id) {
          picker.querySelectorAll('.cw-variant-card').forEach(function(c) {
            c.classList.remove('cw-variant-card--selected');
          });
          card.classList.add('cw-variant-card--selected');
        }
      });
    }
    var savings = 0;
    var activeCard = getActiveCard();
    if (activeCard) savings = parseInt(activeCard.dataset.variantSavings, 10) || 0;
    updateAtcOverlay(price, qty);
    updateSavings(savings, qty);
    var card = getActiveCard();
    if (card) updateStock(card);
    setTimeout(function() {
      setPriceInBtn(price, qty);
    }, 50);
  });

var footerObserver = new MutationObserver(function() {
  var btn = drawer.querySelector('product-form button[name="add"]');
  if (!btn || btn.dataset.cwPriceBound) return;
  btn.dataset.cwPriceBound = 'true';
  var oldSpan = btn.querySelector('.cw-qs-btn-price');
  if (oldSpan) oldSpan.remove();
  var card = getActiveCard();
  if (card) {
    setPriceInBtn(parseInt(card.dataset.variantPrice, 10) || 0, getQty());
  }
});

  var footer = drawer.querySelector('.drawer__footer');
  if (footer) {
    footerObserver.observe(footer, { childList: true, subtree: true });
  }

  var contentObserver = new MutationObserver(function() {
    bindCards();
    bindQty();
    setTimeout(refreshUI, 100);
  });

  contentObserver.observe(drawer, { childList: true, subtree: true });
})();

document.addEventListener('click', function(e) {
  var overlay = e.target.closest('.quick-add-drawer .cw-atc-overlay');
  if (!overlay) return;
  var wrapper = overlay.closest('.cw-atc-wrapper');
  if (!wrapper) return;
  var btn = wrapper.querySelector('.cw-atc-btn');
  if (btn) {
    btn.click();
  } else {
    var form = overlay.closest('form');
    if (form) form.dispatchEvent(new Event('submit', { bubbles: true }));
  }
});